import React from 'react';
import { ChevronDown } from 'lucide-react';

// 省份和城市数据（保持不变，因为这是核心数据）
const provinceData = {
  'Beijing': {
    name: '北京',
    cities: {
      'Beijing': '北京市'
    }
  },
  'Shanghai': {
    name: '上海',
    cities: {
      'Shanghai': '上海市'
    }
  },
  'Tianjin': {
    name: '天津',
    cities: {
      'Tianjin': '天津市'
    }
  },
  'Chongqing': {
    name: '重庆',
    cities: {
      'Chongqing': '重庆市'
    }
  },
  'Hebei': {
    name: '河北',
    cities: {
      'Shijiazhuang': '石家庄市',
      'Tangshan': '唐山市',
      'Qinhuangdao': '秦皇岛市',
      'Handan': '邯郸市',
      'Xingtai': '邢台市',
      'Baoding': '保定市',
      'Zhangjiakou': '张家口市',
      'Chengde': '承德市',
      'Cangzhou': '沧州市',
      'Langfang': '廊坊市',
      'Hengshui': '衡水市'
    }
  },
  'Shanxi': {
    name: '山西',
    cities: {
      'Taiyuan': '太原市',
      'Datong': '大同市',
      'Yangquan': '阳泉市',
      'Changzhi': '长治市',
      'Jincheng': '晋城市',
      'Shuozhou': '朔州市',
      'Jinzhong': '晋中市',
      'Yuncheng': '运城市',
      'Xinzhou': '忻州市',
      'Linfen': '临汾市',
      'Lvliang': '吕梁市'
    }
  },
  'InnerMongolia': {
    name: '内蒙古',
    cities: {
      'Hohhot': '呼和浩特市',
      'Baotou': '包头市',
      'Wuhai': '乌海市',
      'Chifeng': '赤峰市',
      'Tongliao': '通辽市',
      'Ordos': '鄂尔多斯市',
      'Hulunbuir': '呼伦贝尔市',
      'Bayannur': '巴彦淖尔市',
      'Ulanqab': '乌兰察布市'
    }
  },
  'Liaoning': {
    name: '辽宁',
    cities: {
      'Shenyang': '沈阳市',
      'Dalian': '大连市',
      'Anshan': '鞍山市',
      'Fushun': '抚顺市',
      'Benxi': '本溪市',
      'Dandong': '丹东市',
      'Jinzhou': '锦州市',
      'Yingkou': '营口市',
      'Fuxin': '阜新市',
      'Liaoyang': '辽阳市',
      'Panjin': '盘锦市',
      'Tieling': '铁岭市',
      'Chaoyang': '朝阳市',
      'Huludao': '葫芦岛市'
    }
  },
  'Jilin': {
    name: '吉林',
    cities: {
      'Changchun': '长春市',
      'JilinCity': '吉林市',
      'Siping': '四平市',
      'Liaoyuan': '辽源市',
      'Tonghua': '通化市',
      'Baishan': '白山市',
      'Songyuan': '松原市',
      'Baicheng': '白城市'
    }
  },
  'Heilongjiang': {
    name: '黑龙江',
    cities: {
      'Harbin': '哈尔滨市',
      'Qiqihar': '齐齐哈尔市',
      'Jixi': '鸡西市',
      'Hegang': '鹤岗市',
      'Shuangyashan': '双鸭山市',
      'Daqing': '大庆市',
      'Yichun': '伊春市',
      'Jiamusi': '佳木斯市',
      'Qitaihe': '七台河市',
      'Mudanjiang': '牡丹江市',
      'Heihe': '黑河市',
      'Suihua': '绥化市'
    }
  },
  'Jiangsu': {
    name: '江苏',
    cities: {
      'Nanjing': '南京市',
      'Wuxi': '无锡市',
      'Xuzhou': '徐州市',
      'Changzhou': '常州市',
      'Suzhou': '苏州市',
      'Nantong': '南通市',
      'Lianyungang': '连云港市',
      'Huaian': '淮安市',
      'Yancheng': '盐城市',
      'Yangzhou': '扬州市',
      'Zhenjiang': '镇江市',
      'Taizhou': '泰州市',
      'Suqian': '宿迁市'
    }
  },
  'Zhejiang': {
    name: '浙江',
    cities: {
      'Hangzhou': '杭州市',
      'Ningbo': '宁波市',
      'Wenzhou': '温州市',
      'Jiaxing': '嘉兴市',
      'Huzhou': '湖州市',
      'Shaoxing': '绍兴市',
      'Jinhua': '金华市',
      'Quzhou': '衢州市',
      'Zhoushan': '舟山市',
      'Taizhou': '台州市',
      'Lishui': '丽水市'
    }
  },
  'Anhui': {
    name: '安徽',
    cities: {
      'Hefei': '合肥市',
      'Wuhu': '芜湖市',
      'Bengbu': '蚌埠市',
      'Huainan': '淮南市',
      'Maanshan': '马鞍山市',
      'Huaibei': '淮北市',
      'Tongling': '铜陵市',
      'Anqing': '安庆市',
      'Huangshan': '黄山市',
      'Chuzhou': '滁州市',
      'Fuyang': '阜阳市',
      'Suzhou': '宿州市',
      'Lu\'an': '六安市',
      'Bozhou': '亳州市',
      'Chizhou': '池州市',
      'Xuancheng': '宣城市'
    }
  },
  'Fujian': {
    name: '福建',
    cities: {
      'Fuzhou': '福州市',
      'Xiamen': '厦门市',
      'Putian': '莆田市',
      'Sanming': '三明市',
      'Quanzhou': '泉州市',
      'Zhangzhou': '漳州市',
      'Nanping': '南平市',
      'Longyan': '龙岩市',
      'Ningde': '宁德市'
    }
  },
  'Jiangxi': {
    name: '江西',
    cities: {
      'Nanchang': '南昌市',
      'Jingdezhen': '景德镇市',
      'Pingxiang': '萍乡市',
      'Jiujiang': '九江市',
      'Xinyu': '新余市',
      'Yingtan': '鹰潭市',
      'Ganzhou': '赣州市',
      'Jian': '吉安市',
      'Yichun': '宜春市',
      'Fuzhou': '抚州市',
      'Shangrao': '上饶市'
    }
  },
  'Shandong': {
    name: '山东',
    cities: {
      'Jinan': '济南市',
      'Qingdao': '青岛市',
      'Zibo': '淄博市',
      'Zaozhuang': '枣庄市',
      'Dongying': '东营市',
      'Yantai': '烟台市',
      'Weifang': '潍坊市',
      'Jining': '济宁市',
      'Taian': '泰安市',
      'Weihai': '威海市',
      'Rizhao': '日照市',
      'Laiwu': '莱芜市',
      'Linyi': '临沂市',
      'Dezhou': '德州市',
      'Liaocheng': '聊城市',
      'Binzhou': '滨州市',
      'Heze': '菏泽市'
    }
  },
  'Henan': {
    name: '河南',
    cities: {
      'Zhengzhou': '郑州市',
      'Kaifeng': '开封市',
      'Luoyang': '洛阳市',
      'Pingdingshan': '平顶山市',
      'Anyang': '安阳市',
      'Hebi': '鹤壁市',
      'Xinxiang': '新乡市',
      'Jiaozuo': '焦作市',
      'Puyang': '濮阳市',
      'Xuchang': '许昌市',
      'Luohe': '漯河市',
      'Sanmenxia': '三门峡市',
      'Nanyang': '南阳市',
      'Shangqiu': '商丘市',
      'Xinyang': '信阳市',
      'Zhoukou': '周口市',
      'Zhumadian': '驻马店市'
    }
  },
  'Hubei': {
    name: '湖北',
    cities: {
      'Wuhan': '武汉市',
      'Huangshi': '黄石市',
      'Shiyan': '十堰市',
      'Yichang': '宜昌市',
      'Xiangyang': '襄阳市',
      'Ezhou': '鄂州市',
      'Jingmen': '荆门市',
      'Xiaogan': '孝感市',
      'Jingzhou': '荆州市',
      'Huanggang': '黄冈市',
      'Xianning': '咸宁市',
      'Suizhou': '随州市'
    }
  },
  'Hunan': {
    name: '湖南',
    cities: {
      'Changsha': '长沙市',
      'Zhuzhou': '株洲市',
      'Xiangtan': '湘潭市',
      'Hengyang': '衡阳市',
      'Shaoyang': '邵阳市',
      'Yueyang': '岳阳市',
      'Changde': '常德市',
      'Zhangjiajie': '张家界市',
      'Yiyang': '益阳市',
      'Chenzhou': '郴州市',
      'Yongzhou': '永州市',
      'Huaihua': '怀化市',
      'Loudi': '娄底市'
    }
  },
  'Guangdong': {
    name: '广东',
    cities: {
      'Guangzhou': '广州市',
      'Shaoguan': '韶关市',
      'Shenzhen': '深圳市',
      'Zhuhai': '珠海市',
      'Shantou': '汕头市',
      'Foshan': '佛山市',
      'Jiangmen': '江门市',
      'Zhanjiang': '湛江市',
      'Maoming': '茂名市',
      'Zhaoqing': '肇庆市',
      'Huizhou': '惠州市',
      'Meizhou': '梅州市',
      'Shanwei': '汕尾市',
      'Heyuan': '河源市',
      'Yangjiang': '阳江市',
      'Qingyuan': '清远市',
      'Dongguan': '东莞市',
      'Zhongshan': '中山市',
      'Chaozhou': '潮州市',
      'Jieyang': '揭阳市',
      'Yunfu': '云浮市'
    }
  },
  'Guangxi': {
    name: '广西',
    cities: {
      'Nanning': '南宁市',
      'Liuzhou': '柳州市',
      'Guilin': '桂林市',
      'Wuzhou': '梧州市',
      'Beihai': '北海市',
      'Fangchenggang': '防城港市',
      'Qinzhou': '钦州市',
      'Guigang': '贵港市',
      'Yulin': '玉林市',
      'Baise': '百色市',
      'Hezhou': '贺州市',
      'Hechi': '河池市',
      'Laibin': '来宾市',
      'Chongzuo': '崇左市'
    }
  },
  'Hainan': {
    name: '海南',
    cities: {
      'Haikou': '海口市',
      'Sanya': '三亚市',
      'Sansha': '三沙市',
      'Danzhou': '儋州市'
    }
  },
  'Sichuan': {
    name: '四川',
    cities: {
      'Chengdu': '成都市',
      'Zigong': '自贡市',
      'Panzhihua': '攀枝花市',
      'Luzhou': '泸州市',
      'Deyang': '德阳市',
      'Mianyang': '绵阳市',
      'Guangyuan': '广元市',
      'Suining': '遂宁市',
      'Neijiang': '内江市',
      'Leshan': '乐山市',
      'Nanchong': '南充市',
      'Meishan': '眉山市',
      'Yibin': '宜宾市',
      'Guangan': '广安市',
      'Dazhou': '达州市',
      'Yaan': '雅安市',
      'Bazhong': '巴中市',
      'Ziyang': '资阳市'
    }
  },
  'Guizhou': {
    name: '贵州',
    cities: {
      'Guiyang': '贵阳市',
      'Liupanshui': '六盘水市',
      'Zunyi': '遵义市',
      'Anshun': '安顺市',
      'Bijie': '毕节市',
      'Tongren': '铜仁市'
    }
  },
  'Yunnan': {
    name: '云南',
    cities: {
      'Kunming': '昆明市',
      'Qujing': '曲靖市',
      'Yuxi': '玉溪市',
      'Baoshan': '保山市',
      'Zhaotong': '昭通市',
      'Lijiang': '丽江市',
      'Puer': '普洱市',
      'Lincang': '临沧市'
    }
  },
  'Tibet': {
    name: '西藏',
    cities: {
      'Lhasa': '拉萨市',
      'Shigatse': '日喀则市',
      'Chamdo': '昌都市',
      'Nyingchi': '林芝市',
      'Shannan': '山南市',
      'Nagqu': '那曲市'
    }
  },
  'Shaanxi': {
    name: '陕西',
    cities: {
      'Xian': '西安市',
      'Tongchuan': '铜川市',
      'Baoji': '宝鸡市',
      'Xianyang': '咸阳市',
      'Weinan': '渭南市',
      'Yanan': '延安市',
      'Hanzhong': '汉中市',
      'Yulin': '榆林市',
      'Ankang': '安康市',
      'Shangluo': '商洛市'
    }
  },
  'Gansu': {
    name: '甘肃',
    cities: {
      'Lanzhou': '兰州市',
      'Jiayuguan': '嘉峪关市',
      'Jinchang': '金昌市',
      'Baiyin': '白银市',
      'Tianshui': '天水市',
      'Wuwei': '武威市',
      'Zhangye': '张掖市',
      'Pingliang': '平凉市',
      'Jiuquan': '酒泉市',
      'Qingyang': '庆阳市',
      'Dingxi': '定西市',
      'Longnan': '陇南市'
    }
  },
  'Qinghai': {
    name: '青海',
    cities: {
      'Xining': '西宁市',
      'Haidong': '海东市'
    }
  },
  'Ningxia': {
    name: '宁夏',
    cities: {
      'Yinchuan': '银川市',
      'Shizuishan': '石嘴山市',
      'Wuzhong': '吴忠市',
      'Guyuan': '固原市',
      'Zhongwei': '中卫市'
    }
  },
  'Xinjiang': {
    name: '新疆',
    cities: {
      'Urumqi': '乌鲁木齐市',
      'Karamay': '克拉玛依市',
      'Turpan': '吐鲁番市',
      'Hami': '哈密市'
    }
  },
  'HongKong': {
    name: '香港',
    cities: {
      'HongKong': '香港'
    }
  },
  'Macao': {
    name: '澳门',
    cities: {
      'Macao': '澳门'
    }
  },
  'Taiwan': {
    name: '台湾',
    cities: {
      'Taipei': '台北市',
      'Kaohsiung': '高雄市',
      'Taichung': '台中市',
      'Tainan': '台南市',
      'Taoyuan': '桃园市',
      'NewTaipei': '新北市'
    }
  }
};

const ProvinceCitySelect = ({ provinceValue, cityValue, onProvinceChange, onCityChange }) => {
  // 获取选中省份的城市数据
  const selectedProvinceCities = provinceValue ? provinceData[provinceValue]?.cities || {} : {};

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          省份/直辖市 <span className="text-red-500 ml-1">*</span>
        </label>
        <div className="relative">
          <select
            value={provinceValue}
            onChange={(e) => onProvinceChange(e.target.value)}
            className="w-full h-12 px-4 py-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gradient-to-r from-white to-gray-50 shadow-sm hover:shadow-md transition-all duration-200 appearance-none cursor-pointer font-medium"
          >
            <option value="" className="text-gray-500">请选择省份</option>
            {Object.entries(provinceData).map(([key, province]) => (
              <option key={key} value={key} className="text-gray-800 py-2">{province.name}</option>
            ))}
          </select>
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <ChevronDown className="h-5 w-5 text-gray-400" />
          </div>
        </div>
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          城市/地区 <span className="text-red-500 ml-1">*</span>
        </label>
        <div className="relative">
          <select
            value={cityValue}
            onChange={(e) => onCityChange(e.target.value)}
            disabled={!provinceValue}
            className="w-full h-12 px-4 py-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gradient-to-r from-white to-gray-50 shadow-sm hover:shadow-md transition-all duration-200 appearance-none cursor-pointer font-medium disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed disabled:shadow-none"
          >
            <option value="" className="text-gray-500">{!provinceValue ? '请先选择省份' : '请选择城市'}</option>
            {Object.entries(selectedProvinceCities).map(([key, cityName]) => (
              <option key={key} value={key} className="text-gray-800 py-2">{cityName}</option>
            ))}
          </select>
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <ChevronDown className="h-5 w-5 text-gray-400" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProvinceCitySelect;
export { provinceData };
